import { css } from 'canoe';
import { Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import { RuleGroup } from 'dashboard/pages/Segment/components/RuleGroup';
import { SegmentDefinition } from 'dashboard/pages/Segment/components/types';

import { adjustInitialValues, parseSegmentValues } from './utils';
import { validationSchema } from './validationSchema';

const FormActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    margin-top: ${theme.spaces.xl};
  `}
`;

export interface DefinitionFormProps {
  definition: SegmentDefinition;
  segmentId: string;
  onUpdate: (def: SegmentDefinition) => void;
  readOnly?: boolean;
  children?: React.ReactNode;
}

export const DefinitionFormRaw = ({
  definition,
  onUpdate,
  readOnly,
  children,
}: DefinitionFormProps) => {
  const initialValues = useMemo(() => {
    return { definition: adjustInitialValues(definition) };
  }, [definition]);

  return (
    <div data-cy="definition-form-wrapper">
      <Formik
        initialValues={initialValues}
        validateOnBlur={false}
        validationSchema={validationSchema}
        onSubmit={(values) => onUpdate(parseSegmentValues(values.definition))}
        enableReinitialize
      >
        <Form>
          <RuleGroup readOnly={readOnly} />
          <FormActions data-cy="segment-definition-form-actions">{children}</FormActions>
        </Form>
      </Formik>
    </div>
  );
};
